if (!customElements.get('gated-popup')) {
    /**
   * Set cookie.
   * @param {String} name
   * @param {String} value
   * @param {Number} days
   * @returns Void
   */
  const localSetCookie = (name, value, days) => {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  };

  /**
   * Get cookie data.
   * @param {String} name
   * @returns {String|Null}|
   */
  const localGetCookie = (name) => {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  /**
 * UTM Parameter
 */
  // Function to get UTM parameter values from the URL
  function getUTMParam(param) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  // Capture UTM parameters
  let utmMedium = getUTMParam('utm_medium');
  let utmSource = getUTMParam('utm_source');
  document.querySelector('.gated-popup').classList.remove('hidden');
  // Set them as data attributes on the body or any other element
  if (utmMedium) {
    document.body.setAttribute('data-utm-medium', utmMedium);
    document.querySelector('.gated-popup').classList.add('hidden');
  }
  if (utmSource) {
    document.body.setAttribute('data-utm-source', utmSource);
    document.querySelector('.gated-popup').classList.add('hidden');
  }

  let dataUtmMedium = document.body.getAttribute('data-utm-medium');
  let dataUtmSource = document.body.getAttribute('data-utm-source');
  document.addEventListener('DOMContentLoaded', function () {
    let paramElement = document.querySelector('.gated-popup');
    if (paramElement) {
      let utmMediumParams = paramElement.getAttribute('data-utm-medium-params');
      let utmSourceParams = paramElement.getAttribute('data-utm-source-params');
      if (dataUtmMedium && utmMediumParams) {
        // Convert data-utm-medium-params to an array
        let excludeMediums = utmMediumParams.split(',');

        // Check if the dataUtmMedium exists in the excludeMediums array
        if (excludeMediums.includes(dataUtmMedium)) {
          document.querySelector('.gated-popup').classList.add('hidden_utm');
        } else {
          document.querySelector('.gated-popup').classList.remove('hidden');
        }
      }
      if (dataUtmSource && utmSourceParams) {
        // Convert data-utm-source-params to an array
        let excludeSource = utmSourceParams.split(',');

        // Check if the dataUtmSource exists in the excludeSource array
        if (excludeSource.includes(dataUtmSource)) {
          document.querySelector('.gated-popup').classList.add('hidden_utm');
        } else {
          document.querySelector('.gated-popup').classList.remove('hidden');
        }
      }
    }
  });

  class GatedPopup extends HTMLElement {
    constructor() {
      super();
    }

    #form;

    hide() {
      this.classList.add('hidden');
    }

    handleErrors = (errors) => {
      this.querySelector('[data-success]').classList.add('hidden');
      this.querySelector('[data-errors]').innerHTML = errors.join(' ');
      this.querySelector('[data-errors]').classList.remove('hidden');
    };

    handleSuccess = () => {
      this.querySelector('[data-errors]').classList.add('hidden');
      this.querySelector('[data-success]').classList.remove('hidden');

      localSetCookie('is-subscribed', 'true', 2147483647);
      this.hide();
    };

    disconnectedCallback() {
      if(localGetCookie('is-subscribed')) return;

      window.location.href = window.location.href;
    }

    connectedCallback() {
      if(localGetCookie('is-subscribed')) return this.hide();

      const listID = this.getAttribute('data-list-id')

      this.classList.add('is-initialized');

      this.#form = this.querySelector('form');
      this.#form.addEventListener('submit', async (event) => {
        this.#form.reportValidity()
        event.preventDefault();

        if(!this.#form.checkValidity()) return;

        const formData = new FormData(this.#form);
        const email = formData.get('email');
        const url = this.#form.getAttribute('data-ajax-submit');
        const response = await fetch(url, {
          method: 'POST',
          headers: {revision: '2025-01-15', 'content-type': 'application/vnd.api+json'},
          body: JSON.stringify({
            "data": {
              "type": "subscription",
              "attributes": {
                "custom_source": "Gated Sale Page",
                "profile": {
                  "data": {
                    "type": "profile",
                    "attributes": {
                      "email": email,
                      "subscriptions": {
                        "email": {
                          "marketing": {
                            "consent": "SUBSCRIBED"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "relationships": {
                "list": {
                  "data": {
                    "type": "list",
                    "id": listID
                  }
                }
              }
            },
          }),
        });

        if (!response.ok) {
          const data = await response.json();
          return this.handleErrors(data.errors.map((error) => error.detail));
        }

        this.handleSuccess();
      });
    }
  }

  customElements.define('gated-popup', GatedPopup);
}
